import { ACCESS_TIER, type AccessTier } from "@/lib/db/schema";

/**
 * A premium chapter stops requiring payment at its scheduled instant. The
 * stored tier stays premium so the schedule remains visible to the author;
 * callers must use this helper (or the equivalent SQL predicate) when deciding
 * whether access or payment is required.
 */
export function isChapterPaidAt(
  accessTier: AccessTier,
  freeAfter: Date | null | undefined,
  now: Date = new Date(),
) {
  return (
    accessTier === ACCESS_TIER.PREMIUM &&
    (freeAfter == null || freeAfter.getTime() > now.getTime())
  );
}
